import React from "react";

type Props = {};

const Feed = (props: Props) => {
  return <div>Feed</div>;
};

export default Feed;
